import { ColumnSort, flexRender, HeaderGroup, Table } from '@tanstack/react-table';
import { getHeaderClassName } from '../../components/Learn/LearnBlocks/BlockTable';
import * as React from 'react';

export function getHeaderGroups<DataType>(headerGroups: HeaderGroup<DataType>[], sorting: ColumnSort[]) {
  return headerGroups.map((headerGroup, i) => (
    <div key={headerGroup.id} className={headerGroups.length === 2 && i === 0 ? 'rt-thead -headerGroups' : 'rt-thead -header'}>
      <div
        {...{
          key: headerGroup.id,
          className: 'rt-tr',
          role: 'row',
        }}
      >
        {headerGroup.headers.map(header => (
          // eslint-disable-next-line react/jsx-key
          <div
            {...{
              key: header.id,
              className: getHeaderClassName<DataType>(header, sorting),
              onClick: header.column.getToggleSortingHandler(),
              role: 'columnheader',
              style: {
                width: header.getSize(),
                flex: `${header.getSize()} 0 auto`,
              },
            }}
          >
            {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
          </div>
        ))}
      </div>
    </div>
  ));
}

export function getFooterGroups<DataType>(table: Table<DataType>) {
  return (
    table.getFooterGroups()?.length > 0 &&
    table.getFooterGroups()[0].headers[0].column.columnDef.footer && (
      <div className="rt-tfoot">
        {table.getFooterGroups().map(footerGroup => (
          // eslint-disable-next-line react/jsx-key
          <div
            {...{
              key: footerGroup.id,
              className: `rt-tr`,
            }}
          >
            {footerGroup.headers.map(footer => (
              // eslint-disable-next-line react/jsx-key
              <div
                {...{
                  key: footer.column.columnDef.id,
                  // @ts-ignore
                  className: `rt-td ${footer.column.columnDef.meta?.className ?? ''}`,
                  style: {
                    flex: `${footer.column.getSize()} 0 auto`,
                    width: footer.column.getSize(),
                  },
                }}
              >
                {flexRender(footer.column.columnDef.footer, footer.getContext())}
              </div>
            ))}
          </div>
        ))}
      </div>
    )
  );
}
